module.exports = __webpack_public_path__ + "static/media/discover_4.2cad3d33.svg";